module.exports = __webpack_public_path__ + "static/media/do_you_listen_to_love_songs_alone.5ce4c67b.mp4";